export class DeleteCoverError extends Error {
  constructor() {
    super('Não foi possível deletar a capa do livro')
  }
}
